import {loadStripe} from '@stripe/stripe-js';

let stripe
(async () => {
    stripe = await loadStripe(stripe_pk)
    window.stripe = stripe
    if ($(".donation-form").length) {
        initStripeForm()
    }
})()

$(document).on('turbolinks:load', function () {
    if(typeof stripe !== 'undefined') {
        let donateForm = document.querySelector('#v2-donate-form');
        if (donateForm) {
            initStripeForm();
        }
    }

    $(document).on('click', ".amounts-grid a", function (e) {
        e.preventDefault()
        $(e.target).addClass('selected')
        $(e.target).siblings().removeClass('selected')

        let hiddenAmountField = $("#amount-hidden")
        hiddenAmountField.val($(e.target).attr('data-amount'))
    })

    $(document).on('click', "#other-amount-btn", function () {
        $(".amount-field").removeClass('hidden')
        $(".amount-field input").prop('disabled', false)
    })

    $(document).on("click", ".amounts-grid a:not(#other-amount-btn)", function () {
        $(".amount-field").addClass('hidden')
        $(".amount-field input").prop('disabled', true)
    })
})

function initStripeForm() {
    let elements = stripe.elements({
        fonts: [
            {
                cssSrc: 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,900',
            },
        ],
        locale: 'en',
    });

    let elementStyles = {
        base: {
            color: 'rgba(0, 0, 0, 0.87)',
            fontWeight: 500,
            fontFamily: "'TTCommons-Medium', sans-serif",
            fontSize: '14px',
            fontSmoothing: 'antialiased',
            lineHeight: '22px',
            '::placeholder': {
                color: 'rgba(0, 0, 0, 0.6)',
            },
            padding: "50px"
        },
        empty: {
            color: 'rgba(0, 0, 0, 0.6)'
        },
        invalid: {
            color: 'rgba(0, 0, 0, 0.87)',
            ':focus': {
                color: 'rgba(0, 0, 0, 0.87)',
            },
            '::placeholder': {
                color: 'rgba(0, 0, 0, 0.87)',
            },
        },
    };

    let elementClasses = {
        focus: 'focus',
        empty: 'empty',
        invalid: 'invalid',
    };

    let v2CardNumber = elements.create('cardNumber', {
        style: elementStyles,
        classes: elementClasses,
        placeholder: '0000-0000-0000-0000',
    });
    let v2CardNumberContainer = document.querySelector('.card-information__container.card-number');
    if (v2CardNumberContainer) {
        let cardNumberLabel = document.createElement('label');
        cardNumberLabel.setAttribute('for', 'v2-card-number');
        cardNumberLabel.innerText = 'Card Number';
        v2CardNumberContainer.insertBefore(cardNumberLabel, document.querySelector('#v2-card-number'));
        let cardNumberSpan = document.createElement('span');
        cardNumberSpan.innerText = 'Please type a valid card number. Must have 16 digits.';
        cardNumberSpan.classList.add('invalid-feedback');
        v2CardNumberContainer.appendChild(cardNumberSpan);
    }
    v2CardNumber.mount('#v2-card-number');

    let v2CardExpiry = elements.create('cardExpiry', {
        style: elementStyles,
        classes: elementClasses,
        placeholder: document.querySelector('#v2-card-expiry').dataset.default,
    });

    let v2CardExpiryContainer = document.querySelector('.card-information__container.card-expiry');
    if (v2CardExpiryContainer) {
        let cardExpiryLabel = document.createElement('label');
        cardExpiryLabel.setAttribute('for', 'v2-card-expiry');
        cardExpiryLabel.innerText = 'Expiration date';
        v2CardExpiryContainer.insertBefore(cardExpiryLabel, document.querySelector('#v2-card-expiry'));
        let cardExpirySpan = document.createElement('span');
        cardExpirySpan.innerText = 'Card must be active.';
        cardExpirySpan.classList.add('invalid-feedback');
        v2CardExpiryContainer.appendChild(cardExpirySpan);
    }
    v2CardExpiry.mount('#v2-card-expiry');

    let v2CardCvc = elements.create('cardCvc', {
        style: elementStyles,
        classes: elementClasses,
        placeholder: '000',
    });
    let v2CardCvcContainer = document.querySelector('.card-information__container.card-cvc');
    if (v2CardCvcContainer) {
        let cardCvcLabel = document.createElement('label');
        cardCvcLabel.setAttribute('for', 'v2-card-cvc');
        cardCvcLabel.innerText = 'CVC';
        v2CardCvcContainer.insertBefore(cardCvcLabel, document.querySelector('#v2-card-cvc'));
        let cardCvcSpan = document.createElement('span');
        cardCvcSpan.innerText = 'Please type a valid number. Must have 3 digits.';
        cardCvcSpan.classList.add('invalid-feedback');
        v2CardCvcContainer.appendChild(cardCvcSpan);
    }
    v2CardCvc.mount('#v2-card-cvc');

    let v2CardZip = elements.create('postalCode', {
        style: elementStyles,
        classes: elementClasses,
        placeholder: '00000',
    });
    let v2CardZipContainer = document.querySelector('.card-information__container.card-zip');
    if (v2CardZipContainer) {
        let cardZipLabel = document.createElement('label');
        cardZipLabel.setAttribute('for', 'v2-card-zip');
        cardZipLabel.innerText = 'Zip Code';
        v2CardZipContainer.insertBefore(cardZipLabel, document.querySelector('#v2-card-zip'));
        let cardZipSpan = document.createElement('span');
        cardZipSpan.innerText = 'Please type a valid ZIP code. The right format is 00000.';
        cardZipSpan.classList.add('invalid-feedback');
        v2CardZipContainer.appendChild(cardZipSpan);
    }

    v2CardZip.mount('#v2-card-zip');
    registerElements([v2CardNumber, v2CardExpiry, v2CardCvc, v2CardZip], ".donation-form")
}

function registerElements(elements, formHolderClass) {

    var formHolder = document.querySelector(formHolderClass);

    var form = formHolder.querySelector('form');
    var error = form.querySelector('.error');
    var errorMessage = error.querySelector('.message');

    let studentName = $(".student-name").text()

    // Listen for errors from each Element, and show error messages in the UI.
    const savedErrors = [
        {   
            id: 0,
            elementId: 'v2-card-number',
            containerClass: 'card-information__container.card-number',
        },
        {
            id: 1,
            elementId: 'v2-card-expiry',
            containerClass: 'card-information__container.card-expiry'
        },
        {
            id: 2,
            elementId: 'v2-card-cvc',
            containerClass: 'card-information__container.card-cvc'
        },
        {
            id: 3,
            elementId: 'v2-card-zip',
            containerClass: 'card-information__container.card-zip'
        }
    ]
    
    let zipValidation = undefined;
    elements.forEach(function (element, idx) { 
        element.on('change', function (event) {
            if (event.error) {
                const container = formHolder.querySelector(`.${savedErrors[idx].containerClass}`);
                const errorMessage = container.querySelector('span');
                errorMessage.innerText = event.error.message;
            }
        });            
    });
    


    // Listen on the form's 'submit' handler...
    form.addEventListener('submit', function (e) {
        // if (formHolder.classList.contains('submitting')) return;
        e.preventDefault();

        formHolder.querySelectorAll('input[type="submit"]')[0].setAttribute('disabled', 'true');
        formHolder.querySelectorAll('#submit-2')[0].setAttribute('disabled', 'true');
        formHolder.classList.add('submitting');

        disableInputs();

        var name = form.querySelector('#donation_name');
        var additionalData = {
            name: form.querySelector('#donation_name').value
        };

        stripe.createPaymentMethod({type: 'card', card: elements[0]}, additionalData).then(function (result) {
            enableInputs();
            const nameOnCard = formHolder.querySelector('#name_on_card');
            const emailInput = formHolder.querySelector('#email');
            const customAmount = formHolder.querySelector('#other-amount');

            if (!customAmount.value || parseInt(customAmount.value) < 5) {
                customAmount.classList.add('invalid');
                customAmount.nextElementSibling.style.visibility = 'visible';
            }

            if (!nameOnCard.value) {
                nameOnCard.classList.add('invalid');
                nameOnCard.nextElementSibling.style.visibility = 'visible';
            }
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailInput.value || !emailRegex.test(emailInput.value)) {
                emailInput.classList.add('invalid');
                emailInput.nextElementSibling.style.visibility = 'visible';
            }

            if (!customAmount.value || customAmount.value < 5 || !nameOnCard.value || !emailInput.value || !emailRegex.test(emailInput.value) || result.error) {
                if (!customAmount.value || parseInt(customAmount.value) < 5) {
                    console.log('customAmount', customAmount.value);
                    
                    document.querySelector('.donate-form__amount--custom').scrollIntoView({
                        behavior: 'smooth', // for smooth scrolling
                        block: 'start'      // aligns the element at the top of the viewport
                    });
                } else {
                    document.getElementById('donate-form__step--credit-card-information').scrollIntoView({
                        behavior: 'smooth', // for smooth scrolling
                        block: 'start'      // aligns the element at the top of the viewport
                    });    
                }

                formHolder.classList.remove('submitting');
                formHolder.querySelectorAll('input[type="submit"]')[0].removeAttribute('disabled');
                formHolder.querySelectorAll('#submit-2')[0].removeAttribute('disabled');
            } else {
                formHolder.querySelector('#payment_method_id').value = result.paymentMethod.id;
                const $form = $('#v2-donate-form');
                
                let notificationTimer;
                $(".notification-container.alert-success").find("span").html("Processing...");
                $(".notification-container.alert-success").css("display", "flex");
                $(".notification-container.alert-success")[0].classList.add(
                    "animate__animated",
                    "animate__bounceIn"
                );
                clearTimeout(notificationTimer);
                notificationTimer = 0;
                notificationTimer = setTimeout(function () {
                    $(".notification-container.alert-success").css("display", "none");
                    $(".notification-container.alert-success")[0].classList.remove(
                    "animate__animated",
                    "animate__bounceIn"
                    );
                }, 1000);
                  
                $('.loading-indicator').css('display', 'inline-block');
                Rails.ajax({
                    url: $form.attr("action"),
                    type: 'POST',
                    data: Rails.serializeElement(Rails.$("#v2-donate-form")[0]),
                    success: (result) => {
                        eval('result');
                        formHolder.querySelectorAll('#submit-2')[0].removeAttribute('disabled');
                        formHolder.querySelectorAll('input[type="submit"]')[0].removeAttribute('disabled');
                        enableInputs();
                    },
                    error: (result) => {
                        formHolder.querySelectorAll('#submit-2')[0].removeAttribute('disabled');
                        formHolder.querySelectorAll('input[type="submit"]')[0].removeAttribute('disabled');
                        enableInputs();
                    }
                });
            }
        });
    });
}

function enableInputs() {
    let formInputs = $("#v2-donate-form").find("input[type=text], input[type=email], input[type=tel]")
    formInputs.prop("disabled", false)
}

function disableInputs() {
    let formInputs = $("#v2-donate-form").find("input[type=text], input[type=email], input[type=tel]")
    formInputs.prop("disabled", true)
}
